// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-befa {
  font-family: 'Montserrat' !important;
}

.sidebar {
  width: 260px;
  background: #f8fafc;
  border-right: 1px solid #e3e8ef;
  display: flex;
  flex-direction: column;
  height: 100vh;
  transition: width 0.3s ease;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  font-family: 'Montserrat';
}

.sidebar.collapsed {
  width: 72px; /* Presisi sesuai contoh figma */
}

/* === Sidebar Section === */
.sidebar-section {
  padding: 12px 18px 12px 18px;
}

/* === Header === */
.sidebar .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  margin-top: 8px;
}

.sidebar.collapsed .header {
  justify-content: center;
  margin-top: 10px;
}

.sidebar-logo {
  font-weight: 600;
  font-size: 16px;
  color: #222;
  margin-top: 5px
}

/* === Menu === */
.top-menu {
  margin-top: 10px;
  margin-left: 8px;
}
.top-menu-collapsed {
  margin-top: 10px;
  margin-left: 0px;
  padding-left: 0px;
}
.project {
  margin-top: 20px;
}
/* Keep all your existing leftScroll styles as they are */
.leftScroll {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 120px);
  flex: 1 1;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
  
  /* Hide scrollbar by default */
  scrollbar-width: none;
}

.leftScroll::-webkit-scrollbar {
  width: 6px;
  display: none; /* Hide by default */
}

/* Show scrollbar only when hovering over leftScroll */
.leftScroll:hover {
  scrollbar-width: thin;
}

.leftScroll:hover::-webkit-scrollbar {
  display: block;
}

.leftScroll::-webkit-scrollbar-track {
  background: transparent;
}

.leftScroll::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.leftScroll::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}
.history {
  margin-top: 20px;
  padding-right: 8px;
}

.footer {
  border-top: 0px solid #e5e8ef;
  gap: 10px;
  padding: 30px 30px;
  margin-left: -10px;
  font-size: 13px;
}

.sidebar.collapsed .footer {
  margin-bottom: 20px;
}

/* === Menu Item === */
.menu-item {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 0px;
  border-radius: 10px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
}
.menu-item:hover {
  background: #E8E9EB;
  margin-left: 0px;
  border-radius: 10px;
  color: #333;
  cursor: pointer; 
}
.menu-item-expand {
  padding: 10px 12px 10px 12px;
  border-radius: 10px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  margin-left: -20px;
  margin-right: -15px;
}
.menu-item-expand:hover {
  background: #E8E9EB;
}
/* Saat collapse, ikon tetap di tengah */
.sidebar.collapsed .menu-item {
  justify-content: center;
  padding: 10px 0;
}
.menu-item-content {
  display: flex;
  align-items: center;
}

.content-expanded {
  justify-content: flex-start;
  gap: 12px;
}

.content-collapsed {
  justify-content: center;
}
.history-item:hover .more-icon {
  opacity: 1 !important;
}
.menu-label {
  white-space: nowrap;
}
/* Tooltip untuk collapsed mode */
.menu-tooltip {
  position: absolute;
  left: 75px;
  background: #fff;
  box-shadow: 0px 8px 80px 6px #00000033;
  padding: 6px 10px;
  border-radius: 6px;
  white-space: nowrap;
  font-size: 13px;
  color: #333;
  z-index: 999;
  top: 50%;
  transform: translateY(-50%);
}

/* === History === */
.history h4 {
  font-size: 13px;
  font-weight: 600;
  color: #777;
  margin-bottom: 10px;
}

.history-item {
  font-size: 13px;
  padding: 8px 8px;
  margin-left: 10px;
  border-radius: 6px;
  color: #333;
  cursor: pointer;
}

.history-item:hover {
  background: #E8E9EB;
}

/* === Avatar === */
.user-avatar {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: black;
}

/* === Collapse button === */
.menu-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #333;
  display: flex;
  align-items: center;
}

/* Ikon tetap konsisten */
.menu-item svg,
.menu-btn svg {
  min-width: 22px;
  min-height: 22px;
  flex-shrink: 0;
}

/* Saat collapsed, hilangkan padding kanan agar icon center */
.sidebar.collapsed.sidebar-section {
  padding: 12px 10px 12px 15px;
}

/* Scrollbar kecil di history */
.history::-webkit-scrollbar {
  width: 6px;
}
.history::-webkit-scrollbar-thumb {
  background: #d0d7de;
  border-radius: 10px;
}

.more-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 0px solid #ccc;
  box-shadow: 0px 8px 80px 6px #00000033;
  border-radius: 10px;
  z-index: 1000;
  min-width: 150px;
}

/* === Footer Section === */
.sidebar-section.footer {
  position: relative;
  padding: 10px 12px 10px 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  gap: 10px;
  margin-left: 3px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.sidebar-section.footer:hover{
  background: #E8E9EB;
  border-radius: 10px;
}

.footer-user {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-more-menu {
  position: absolute;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 8px 80px 6px #00000033;
  border: 1px solid #e5e8ef;
  width: 200px;
  z-index: 2000;
  overflow: hidden;
  animation: fadeIn 0.15s ease-in-out;
  font-family: 'Montserrat';
}

/* Hover styling */
.footer-menu-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  transition: background 0.2s ease;
}

.footer-menu-item:hover {
  background: #E8E9EB;
}

.footer-menu-item.user-email {
  font-weight: 500;
  color: #555;
  cursor: default;
  background: #f8fafc;
}

.footer-more-menu.global {
  position: fixed;
  z-index: 10000;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 8px 80px 6px #00000033;
  border: 1px solid #e5e8ef;
  width: 200px;
  overflow: hidden;
  animation: fadeIn 0.15s ease-in-out;
  margin-left: 100px;
  margin-bottom: -10px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Saat sidebar collapse */
.sidebar.collapsed .footer {
  justify-content: center;
  padding: 20px 0;
}

.sidebar.collapsed .footer-more-menu {
  right: auto;
  left: 60px; /* muncul ke kiri avatar, bukan keluar layar */
  bottom: 60px;
  width: 200px;
}

.sidebar {
  position: relative;
  z-index: 1000; /* pastikan di atas Chat.js */
}

.footer-more-menu {
  position: absolute;
  bottom: 60px;
  right: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 8px 80px 6px #00000033;
  border: 1px solid #e5e8ef;
  width: 200px;
  z-index: 3000; /* lebih tinggi dari elemen lain */
  overflow: hidden;
  animation: fadeIn 0.15s ease-in-out;
}

.hoverclass:hover{
  background: #E8E9EB;
}

.portal-tooltip {
  z-index: 9999;
  pointer-events: auto !important; /* So it doesn't interfere with mouse events */
}

.tooltip-content {
  background: white;
  color: black;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  box-shadow: 0px 8px 80px 6px #00000033;
  font-family: 'Montserrat';
  
  /* Optional arrow */
  position: relative;
}

.tooltip-content::before {
  content: '';
  position: absolute;
  left: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-right: 4px solid white;
}

.footer-user {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

/* Ensure sidebar doesn't clip the tooltip */
.sidebar-section.footer {
  overflow: visible !important;
}

.footer-user {
  overflow: visible !important;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(-50%) translateX(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

.user-tooltip {
  position: fixed; /* Changed from absolute to fixed */
  top: auto;
  left: var(--sidebar-width, 60px); /* Adjust based on your sidebar width */
  margin-left: 15px; /* Add some spacing from sidebar */
  background-color: white;
  color: black;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  white-space: nowrap;
  z-index: 10000;
  pointer-events: auto !important;
  margin-top: 5px;
  box-shadow: 0px 8px 80px 6px #00000033;
}

.user-tooltip::after {
  content: '';
  position: absolute;
  top:auto;
  right: 100%; /* Arrow on left side */
  border-width: 6px;
  border-style: solid;
  border-color: transparent white transparent transparent;
}

.footer-divider {
  width: 100%;
  height: 1px;
  background-color: #E8E9EB;
  margin: 8px 0; /* atur jarak sesuai kebutuhan */
}

/* === SWEETALERT CUSTOM === */
.befa-swal {
  width: 620px !important;
  padding: 24px 28px 28px;
  border-radius: 12px;
  font-family: 'Montserrat', sans-serif;
}

.befa-swal-title {
  text-align: left !important;
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 8px;
}

.befa-form {
  margin-top: 12px;
}

.befa-field {
  margin-bottom: 18px;
  text-align: left;
}

.befa-field label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #000;
}

.befa-input,
.befa-textarea {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #E0E6ED;
  padding: 10px 12px;
  font-size: 13px;
  font-family: inherit;
  outline: none;
}

.befa-input:focus,
.befa-textarea:focus {
  border-color: #007bff;
}

.befa-textarea {
  min-height: 90px;
  height: auto;
  resize: none;
}

.befa-btn-primary {
  background: #22aeef !important;
  border-radius: 8px !important;
  padding: 8px 22px !important;
  font-size: 14px !important;
  border: none !important;
  color: white !important;
}

.swal2-close {
  color: #999 !important;
}

.swal2-validation-message {
  font-size: 13px;
}

/* === RIGHT ALIGN CONFIRM BUTTON === */
/* Paksa tombol Simpan ke kanan */
.befa-swal .swal2-actions {
  justify-content: flex-end !important;
}

.befa-swal .swal2-confirm {
  margin-left: auto !important;
}

.befa-swal-white {
  width: 1000px;
  min-height: 500px;
  padding: 16px;
}

.befa-memory-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.befa-title {
  font-weight: 600;
  font-size: 20px;
}

.befa-header-actions {
  display: flex;
  gap: 8px;
}

.befa-btn-add {
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
  margin-right: 30px;
}

.befa-btn-close,
.befa-btn-back {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 23px;
}

.befa-memory-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.befa-btn-delete {
  border: none;
  background: transparent;
  cursor: pointer;
}

.befa-textarea {
  width: 100%;
  min-height: 100px;
  padding: 10px;
  margin-top: 10px;
}

.befa-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.befa-more-wrapper {
  position: relative;
}

.befa-btn-more {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.befa-more-popup {
  position: absolute;
  top: 24px;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 6px;
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  display: none;
  z-index: 10;
  
}

.befa-more-popup.show {
  display: block;
}

.befa-more-popup button {
  width: 100%;
  background: none;
  border: none;
  padding: 8px;
  text-align: left;
  cursor: pointer;
}

.befa-more-popup button:hover {
  background: #f5f5f5;
}

.befa-memory-search {
  margin-bottom: 10px;
}

.befa-input-search {
  width: 50%;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
  font-size: 14px;
}

.befa-input-search:focus {
  outline: none;
  border-color: #5b7cff;
}

/* Toolbar container */
.befa-memory-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

/* Search kecil */
.befa-input-search.small {
  width: 220px;
  padding: 6px 10px;
  font-size: 13px;
  border-radius: 6px;
}

/* Right action group */
.befa-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Sort button */
.befa-btn-sort {
  padding: 6px 10px;
  font-size: 15px;
  border-radius: 6px;
  background: #ffffff;
  border: 0px solid #ddd;
  cursor: pointer;
}

.befa-btn-sort:hover {
  background: #ffffff;
}

/* More horizontal button */
.befa-btn-more {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: #ffffff;
  border: 0px solid #ddd;
  font-size: 15px;
  cursor: pointer;
}

.befa-btn-more:hover {
  background: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/pages/layout/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW,EAAE,gCAAgC;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX;AACF;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,SAAO;EACP,qBAAqB;EACrB,oCAAoC;;EAEpC,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,aAAa,EAAE,oBAAoB;AACrC;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA,wCAAwC;AACxC;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU,EAAE,8CAA8C;EAC1D,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa,EAAE,6BAA6B;AAC9C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;EACZ,aAAa,EAAE,kCAAkC;EACjD,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B,EAAE,8CAA8C;AACjF;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;;EAEzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,eAAe,EAAE,mCAAmC;EACpD,SAAS;EACT,gCAAgC,EAAE,uCAAuC;EACzE,iBAAiB,EAAE,kCAAkC;EACrD,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW,EAAE,uBAAuB;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,aAAa,EAAE,gCAAgC;AACjD;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA,uCAAuC;AACvC,iCAAiC;AACjC;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,WAAW;;AAEb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".font-befa {\r\n  font-family: 'Montserrat' !important;\r\n}\r\n\r\n.sidebar {\r\n  width: 260px;\r\n  background: #f8fafc;\r\n  border-right: 1px solid #e3e8ef;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  transition: width 0.3s ease;\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  z-index: 10;\r\n  font-family: 'Montserrat';\r\n}\r\n\r\n.sidebar.collapsed {\r\n  width: 72px; /* Presisi sesuai contoh figma */\r\n}\r\n\r\n/* === Sidebar Section === */\r\n.sidebar-section {\r\n  padding: 12px 18px 12px 18px;\r\n}\r\n\r\n/* === Header === */\r\n.sidebar .header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.sidebar.collapsed .header {\r\n  justify-content: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.sidebar-logo {\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  color: #222;\r\n  margin-top: 5px\r\n}\r\n\r\n/* === Menu === */\r\n.top-menu {\r\n  margin-top: 10px;\r\n  margin-left: 8px;\r\n}\r\n.top-menu-collapsed {\r\n  margin-top: 10px;\r\n  margin-left: 0px;\r\n  padding-left: 0px;\r\n}\r\n.project {\r\n  margin-top: 20px;\r\n}\r\n/* Keep all your existing leftScroll styles as they are */\r\n.leftScroll {\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  height: calc(100% - 120px);\r\n  flex: 1;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #c1c1c1 transparent;\r\n  \r\n  /* Hide scrollbar by default */\r\n  scrollbar-width: none;\r\n}\r\n\r\n.leftScroll::-webkit-scrollbar {\r\n  width: 6px;\r\n  display: none; /* Hide by default */\r\n}\r\n\r\n/* Show scrollbar only when hovering over leftScroll */\r\n.leftScroll:hover {\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.leftScroll:hover::-webkit-scrollbar {\r\n  display: block;\r\n}\r\n\r\n.leftScroll::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.leftScroll::-webkit-scrollbar-thumb {\r\n  background-color: #c1c1c1;\r\n  border-radius: 3px;\r\n}\r\n\r\n.leftScroll::-webkit-scrollbar-thumb:hover {\r\n  background-color: #a8a8a8;\r\n}\r\n.history {\r\n  margin-top: 20px;\r\n  padding-right: 8px;\r\n}\r\n\r\n.footer {\r\n  border-top: 0px solid #e5e8ef;\r\n  gap: 10px;\r\n  padding: 30px 30px;\r\n  margin-left: -10px;\r\n  font-size: 13px;\r\n}\r\n\r\n.sidebar.collapsed .footer {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* === Menu Item === */\r\n.menu-item {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: 0px;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  color: #333;\r\n  cursor: pointer;\r\n}\r\n.menu-item:hover {\r\n  background: #E8E9EB;\r\n  margin-left: 0px;\r\n  border-radius: 10px;\r\n  color: #333;\r\n  cursor: pointer; \r\n}\r\n.menu-item-expand {\r\n  padding: 10px 12px 10px 12px;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  color: #333;\r\n  cursor: pointer;\r\n  margin-left: -20px;\r\n  margin-right: -15px;\r\n}\r\n.menu-item-expand:hover {\r\n  background: #E8E9EB;\r\n}\r\n/* Saat collapse, ikon tetap di tengah */\r\n.sidebar.collapsed .menu-item {\r\n  justify-content: center;\r\n  padding: 10px 0;\r\n}\r\n.menu-item-content {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.content-expanded {\r\n  justify-content: flex-start;\r\n  gap: 12px;\r\n}\r\n\r\n.content-collapsed {\r\n  justify-content: center;\r\n}\r\n.history-item:hover .more-icon {\r\n  opacity: 1 !important;\r\n}\r\n.menu-label {\r\n  white-space: nowrap;\r\n}\r\n/* Tooltip untuk collapsed mode */\r\n.menu-tooltip {\r\n  position: absolute;\r\n  left: 75px;\r\n  background: #fff;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n  padding: 6px 10px;\r\n  border-radius: 6px;\r\n  white-space: nowrap;\r\n  font-size: 13px;\r\n  color: #333;\r\n  z-index: 999;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n/* === History === */\r\n.history h4 {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #777;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.history-item {\r\n  font-size: 13px;\r\n  padding: 8px 8px;\r\n  margin-left: 10px;\r\n  border-radius: 6px;\r\n  color: #333;\r\n  cursor: pointer;\r\n}\r\n\r\n.history-item:hover {\r\n  background: #E8E9EB;\r\n}\r\n\r\n/* === Avatar === */\r\n.user-avatar {\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 50%;\r\n  background: #ccc;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 600;\r\n  color: black;\r\n}\r\n\r\n/* === Collapse button === */\r\n.menu-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #333;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Ikon tetap konsisten */\r\n.menu-item svg,\r\n.menu-btn svg {\r\n  min-width: 22px;\r\n  min-height: 22px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Saat collapsed, hilangkan padding kanan agar icon center */\r\n.sidebar.collapsed.sidebar-section {\r\n  padding: 12px 10px 12px 15px;\r\n}\r\n\r\n/* Scrollbar kecil di history */\r\n.history::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n.history::-webkit-scrollbar-thumb {\r\n  background: #d0d7de;\r\n  border-radius: 10px;\r\n}\r\n\r\n.more-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  background: white;\r\n  border: 0px solid #ccc;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n  border-radius: 10px;\r\n  z-index: 1000;\r\n  min-width: 150px;\r\n}\r\n\r\n/* === Footer Section === */\r\n.sidebar-section.footer {\r\n  position: relative;\r\n  padding: 10px 12px 10px 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  cursor: pointer;\r\n  gap: 10px;\r\n  margin-left: 3px;\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.sidebar-section.footer:hover{\r\n  background: #E8E9EB;\r\n  border-radius: 10px;\r\n}\r\n\r\n.footer-user {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.footer-more-menu {\r\n  position: absolute;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n  border: 1px solid #e5e8ef;\r\n  width: 200px;\r\n  z-index: 2000;\r\n  overflow: hidden;\r\n  animation: fadeIn 0.15s ease-in-out;\r\n  font-family: 'Montserrat';\r\n}\r\n\r\n/* Hover styling */\r\n.footer-menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px 14px;\r\n  font-size: 13px;\r\n  color: #333;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease;\r\n}\r\n\r\n.footer-menu-item:hover {\r\n  background: #E8E9EB;\r\n}\r\n\r\n.footer-menu-item.user-email {\r\n  font-weight: 500;\r\n  color: #555;\r\n  cursor: default;\r\n  background: #f8fafc;\r\n}\r\n\r\n.footer-more-menu.global {\r\n  position: fixed;\r\n  z-index: 10000;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n  border: 1px solid #e5e8ef;\r\n  width: 200px;\r\n  overflow: hidden;\r\n  animation: fadeIn 0.15s ease-in-out;\r\n  margin-left: 100px;\r\n  margin-bottom: -10px;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(4px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Saat sidebar collapse */\r\n.sidebar.collapsed .footer {\r\n  justify-content: center;\r\n  padding: 20px 0;\r\n}\r\n\r\n.sidebar.collapsed .footer-more-menu {\r\n  right: auto;\r\n  left: 60px; /* muncul ke kiri avatar, bukan keluar layar */\r\n  bottom: 60px;\r\n  width: 200px;\r\n}\r\n\r\n.sidebar {\r\n  position: relative;\r\n  z-index: 1000; /* pastikan di atas Chat.js */\r\n}\r\n\r\n.footer-more-menu {\r\n  position: absolute;\r\n  bottom: 60px;\r\n  right: 20px;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n  border: 1px solid #e5e8ef;\r\n  width: 200px;\r\n  z-index: 3000; /* lebih tinggi dari elemen lain */\r\n  overflow: hidden;\r\n  animation: fadeIn 0.15s ease-in-out;\r\n}\r\n\r\n.hoverclass:hover{\r\n  background: #E8E9EB;\r\n}\r\n\r\n.portal-tooltip {\r\n  z-index: 9999;\r\n  pointer-events: auto !important; /* So it doesn't interfere with mouse events */\r\n}\r\n\r\n.tooltip-content {\r\n  background: white;\r\n  color: black;\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n  font-family: 'Montserrat';\r\n  \r\n  /* Optional arrow */\r\n  position: relative;\r\n}\r\n\r\n.tooltip-content::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -4px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 4px solid transparent;\r\n  border-bottom: 4px solid transparent;\r\n  border-right: 4px solid white;\r\n}\r\n\r\n.footer-user {\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  position: relative;\r\n}\r\n\r\n/* Ensure sidebar doesn't clip the tooltip */\r\n.sidebar-section.footer {\r\n  overflow: visible !important;\r\n}\r\n\r\n.footer-user {\r\n  overflow: visible !important;\r\n}\r\n\r\n@keyframes tooltipFadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-50%) translateX(-5px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(-50%) translateX(0);\r\n  }\r\n}\r\n\r\n.user-tooltip {\r\n  position: fixed; /* Changed from absolute to fixed */\r\n  top: auto;\r\n  left: var(--sidebar-width, 60px); /* Adjust based on your sidebar width */\r\n  margin-left: 15px; /* Add some spacing from sidebar */\r\n  background-color: white;\r\n  color: black;\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  white-space: nowrap;\r\n  z-index: 10000;\r\n  pointer-events: auto !important;\r\n  margin-top: 5px;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n}\r\n\r\n.user-tooltip::after {\r\n  content: '';\r\n  position: absolute;\r\n  top:auto;\r\n  right: 100%; /* Arrow on left side */\r\n  border-width: 6px;\r\n  border-style: solid;\r\n  border-color: transparent white transparent transparent;\r\n}\r\n\r\n.footer-divider {\r\n  width: 100%;\r\n  height: 1px;\r\n  background-color: #E8E9EB;\r\n  margin: 8px 0; /* atur jarak sesuai kebutuhan */\r\n}\r\n\r\n/* === SWEETALERT CUSTOM === */\r\n.befa-swal {\r\n  width: 620px !important;\r\n  padding: 24px 28px 28px;\r\n  border-radius: 12px;\r\n  font-family: 'Montserrat', sans-serif;\r\n}\r\n\r\n.befa-swal-title {\r\n  text-align: left !important;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.befa-form {\r\n  margin-top: 12px;\r\n}\r\n\r\n.befa-field {\r\n  margin-bottom: 18px;\r\n  text-align: left;\r\n}\r\n\r\n.befa-field label {\r\n  display: block;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  margin-bottom: 6px;\r\n  color: #000;\r\n}\r\n\r\n.befa-input,\r\n.befa-textarea {\r\n  width: 100%;\r\n  border-radius: 8px;\r\n  border: 1px solid #E0E6ED;\r\n  padding: 10px 12px;\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n  outline: none;\r\n}\r\n\r\n.befa-input:focus,\r\n.befa-textarea:focus {\r\n  border-color: #007bff;\r\n}\r\n\r\n.befa-textarea {\r\n  min-height: 90px;\r\n  height: auto;\r\n  resize: none;\r\n}\r\n\r\n.befa-btn-primary {\r\n  background: #22aeef !important;\r\n  border-radius: 8px !important;\r\n  padding: 8px 22px !important;\r\n  font-size: 14px !important;\r\n  border: none !important;\r\n  color: white !important;\r\n}\r\n\r\n.swal2-close {\r\n  color: #999 !important;\r\n}\r\n\r\n.swal2-validation-message {\r\n  font-size: 13px;\r\n}\r\n\r\n/* === RIGHT ALIGN CONFIRM BUTTON === */\r\n/* Paksa tombol Simpan ke kanan */\r\n.befa-swal .swal2-actions {\r\n  justify-content: flex-end !important;\r\n}\r\n\r\n.befa-swal .swal2-confirm {\r\n  margin-left: auto !important;\r\n}\r\n\r\n.befa-swal-white {\r\n  width: 1000px;\r\n  min-height: 500px;\r\n  padding: 16px;\r\n}\r\n\r\n.befa-memory-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.befa-title {\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n}\r\n\r\n.befa-header-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.befa-btn-add {\r\n  padding: 4px 10px;\r\n  border-radius: 6px;\r\n  border: 1px solid #ddd;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  margin-right: 30px;\r\n}\r\n\r\n.befa-btn-close,\r\n.befa-btn-back {\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 23px;\r\n}\r\n\r\n.befa-memory-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 10px 0;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.befa-btn-delete {\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n}\r\n\r\n.befa-textarea {\r\n  width: 100%;\r\n  min-height: 100px;\r\n  padding: 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.befa-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 12px;\r\n}\r\n\r\n.befa-more-wrapper {\r\n  position: relative;\r\n}\r\n\r\n.befa-btn-more {\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n}\r\n\r\n.befa-more-popup {\r\n  position: absolute;\r\n  top: 24px;\r\n  right: 0;\r\n  background: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  padding: 6px;\r\n  min-width: 200px;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n  display: none;\r\n  z-index: 10;\r\n  \r\n}\r\n\r\n.befa-more-popup.show {\r\n  display: block;\r\n}\r\n\r\n.befa-more-popup button {\r\n  width: 100%;\r\n  background: none;\r\n  border: none;\r\n  padding: 8px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.befa-more-popup button:hover {\r\n  background: #f5f5f5;\r\n}\r\n\r\n.befa-memory-search {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.befa-input-search {\r\n  width: 50%;\r\n  padding: 8px 10px;\r\n  border-radius: 6px;\r\n  border: 1px solid #ddd;\r\n  font-size: 14px;\r\n}\r\n\r\n.befa-input-search:focus {\r\n  outline: none;\r\n  border-color: #5b7cff;\r\n}\r\n\r\n/* Toolbar container */\r\n.befa-memory-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n/* Search kecil */\r\n.befa-input-search.small {\r\n  width: 220px;\r\n  padding: 6px 10px;\r\n  font-size: 13px;\r\n  border-radius: 6px;\r\n}\r\n\r\n/* Right action group */\r\n.befa-toolbar-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n/* Sort button */\r\n.befa-btn-sort {\r\n  padding: 6px 10px;\r\n  font-size: 15px;\r\n  border-radius: 6px;\r\n  background: #ffffff;\r\n  border: 0px solid #ddd;\r\n  cursor: pointer;\r\n}\r\n\r\n.befa-btn-sort:hover {\r\n  background: #ffffff;\r\n}\r\n\r\n/* More horizontal button */\r\n.befa-btn-more {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 6px;\r\n  background: #ffffff;\r\n  border: 0px solid #ddd;\r\n  font-size: 15px;\r\n  cursor: pointer;\r\n}\r\n\r\n.befa-btn-more:hover {\r\n  background: #ffffff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
